import { type InputHTMLAttributes, type ReactElement } from 'react'
import { cn } from '@/lib/utils'

type Props = InputHTMLAttributes<HTMLInputElement>

export function Input ({ className, ...props }: Props): ReactElement {
  return (
    <input
      className={cn(
        'w-full py-[9px] px-3 border border-(--bp-border) rounded-[7px] text-sm text-(--bp-ink) bg-(--bp-surface) outline-none transition-all focus:border-(--bp-accent) focus:shadow-[0_0_0_3px_var(--bp-accent-pale)]',
        className
      )}
      {...props}
    />
  )
}
